
import Vue from "vue";
import store from "@/store";
import router from "@/router";
import { separateDigits, convertToPersian } from "@/utils/string";
import AppLoading from "@/components/UI/AppLoading.vue";
import LandingProductCard from "@/components/admin/landing/products/LandingProductCard.vue";
import AppWarning from "@/components/UI/AppWarning.vue";

export default Vue.extend({
  name: "AdminAllProducts",
  data() {
    return {
      selectedCategory: null,
    };
  },
  components: {
    AppLoading,
    LandingProductCard,
    AppWarning,
  },
  computed: {
    categories(): string[] {
      const categories = store.state.admin.landing.categories;

      let items: any[] = [];

      categories.forEach((category: any) => {
        const item = {
          title: category.persianTitle,
          value: category["_id"],
        };
        items.push(item);
      });

      return items;
    },
    products(): any[] {
      return store.state.admin.landing.landingProducts || [];
    },
  },
  methods: {
    separateDigits,
    convertToPersian,
    pathStyle(text: string): string {
      return text.split("/").splice(1).join(" > ");
    },
    getProducts(id: any): void {
      store.dispatch("admin/getLandingProductsByCategory", id);
    },
    addProduct(): void {
      router.push({
        name: "admin-add-product",
        query: { id: this.selectedCategory },
      });
    },
    editProduct(id: string): void {
      router.push({
        name: "admin-edit-product",
        query: { id: id },
      });
    },
    deleteProduct(id: string): void {
      store.dispatch("admin/deleteProduct", id);
    },
  },
  watch: {
    selectedCategory(newVal) {
      this.getProducts(newVal);
    },
  },

  created() {
    store.dispatch("admin/getAllCategories");
  },
});
